import { AuthorizationResult } from "../../enum/authorization-result.enum";
import { Token } from "../authentication/token.model";

export class AuthorizationResultPayload {
    constructor(
        public token: Token,
        public trustDevice: boolean
    ){}
}